module.exports = __webpack_public_path__ + "static/media/close.e4219d55.svg";